"use strict";
exports.__esModule = true;
exports.toContact = void 0;
var utils_1 = require("@lglp/utils");
var fields_1 = require("../fields");
var toContact = function (data, logger) {
    var prismicContact = utils_1.unprefix('contact', data);
    if (prismicContact) {
        return utils_1.compact({
            image: logger.required(fields_1.toImage(prismicContact.image, logger)),
            title: logger.required(fields_1.toText(prismicContact.title)),
            description: fields_1.toText(prismicContact.description)
        });
    }
    return undefined;
};
exports.toContact = toContact;
//# sourceMappingURL=contact.js.map